<template>
  <div ref="tooltipRef" class="w-fit">
    <slot></slot>
  </div>
</template>

<script>
import tippy from "tippy.js";
import "tippy.js/dist/tippy.css";
import "tippy.js/dist/border.css";
import "tippy.js/animations/scale.css";

export default {
  name: "SimpleTooltip",
  components: {},
  data() {
    return {
      tooltipInstance: null
    };
  },
  props: {
    content: {
      type: String,
      required: true
    }
  },
  mounted() {
    this.initTooltip();
  },
  updated() {
    this.initTooltip();
  },
  unmounted() {
    this.destroyTooltip();
  },
  methods: {
    initTooltip() {
      this.destroyTooltip();
      this.tooltipInstance = tippy(this.$refs.tooltipRef, {
        theme: "abi-ui-tooltip",
        animation: "scale",
        allowHTML: true,
        content: this.content,
        placement: "left"
      });
    },
    destroyTooltip() {
      if (this.tooltipInstance) {
        this.tooltipInstance.destroy();
      }
    }
  }
};
</script>
